



















































import {
  computed, defineComponent, onMounted, reactive, ref,
} from '@vue/composition-api';
import { useRouter, useFormat } from '@ideavivat/vivat-2';

import {
  getWithdraw,
  updateWithdraw,
} from '@/api';
import { Withdraw, WithdrawItem } from '@/types/withdraw';
import useWithdraw from '@/use/useWithdraw';
import withdrawUpdateItemTableOption from '@/table/Withdraw/withdraw-update';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import StickyFooterActionBar from '@/components/StickyFooterActionBar.vue';

const NOW = useFormat.date().computerShortDate();
const defaultWithdraw: Withdraw = {
  id: -1,
  bomId: -1,
  type: '',
  status: '',
  items: [],
  remarks: '',
  createdAt: '',
  updatedAt: '',
  userId: -1,
  deletedAt: '',
};

const PageColumnWithWithdrawUpdate = defineComponent({
  components: {
    StickyFooterActionBar,
    CommonModalWithPreset,
  },
  setup() {
    const { route } = useRouter();
    const {
      translateType, statusClassMap, translateStatus, typeClassMap,
    } = useWithdraw();
    const successModal = ref(null);
    const item: Withdraw = reactive(defaultWithdraw);

    const updateWithdrawInput = computed(() => ({
      bomId: item.bomId,
      status: item.status,
      type: item.type,
      items: item.items.map((withdrawItem: any) => ({
        id: withdrawItem.id,
        filledAmount: parseFloat(withdrawItem.filledAmount) + parseFloat(withdrawItem.amount),
        amount: withdrawItem.neededAmount,
        bomItemId: withdrawItem.bomItemId,
        unit: withdrawItem.unit,
      })),
    }));

    async function updateWithdrawAction() {
      await updateWithdraw(item.id, updateWithdrawInput.value);
      (successModal.value as any).compose({ action: 'บันทึก', entity: 'ใบเบิก' });
    }

    async function initialPage(id: number) {
      const result = (await getWithdraw(id)).data;
      item.id = result.id;
      item.bomId = result.bom_id;
      item.status = result.status;
      item.type = result.type;
      item.items = result.items.map((withdrawItem: any) => ({
        ...withdrawItem,
        id: withdrawItem.id,
        bomItemId: withdrawItem.bom_item_id,
        filledAmount: withdrawItem.filled_amount,
        neededAmount: withdrawItem.amount,
        amount: withdrawItem.amount - withdrawItem.filled_amount,
        unit: withdrawItem.unit,
      })) || [];
      item.createdAt = result.created_at;
      item.updatedAt = result.updated_at;
      item.deletedAt = result.deleted_at;
      item.userId = result.user_id;
      // item.user = result.user;
    }

    onMounted(async () => {
      await initialPage(route.value.params.id);
    });

    // use this to manually paginate pr item;
    const page = ref(1);
    const PERPAGE = 15;
    const paginator = computed(() => ({
      perPage: PERPAGE,
      total: item.items?.length,
      from: (page.value - 1) * PERPAGE,
      to: (page.value * PERPAGE),
      currentPage: 1,
      lastPage: item.items?.length === 0 ? 1 : Math.ceil((item.items as any).length / PERPAGE),
      totalPages: item.items?.length === 0 ? 1 : Math.ceil((item.items as any).length / PERPAGE),
    }));
    const displayData = computed(() => {
      if ((item.items as any).length < paginator.value.to) return (item.items as any).slice(paginator.value.from, (item.items as any).length);
      return (item.items as any).slice(paginator.value.from, paginator.value.to);
    });

    return {
      successModal,
      translateStatus,
      translateType,
      statusClassMap,
      typeClassMap,
      updateWithdrawAction,

      withdrawUpdateItemTableOption,
      item,
      page,
      PERPAGE,
      pagination: paginator,
      displayData,
    };
  },
});

export default PageColumnWithWithdrawUpdate;
